import script from "./addAttendance.vue?vue&type=script&setup=true&lang=js"
export * from "./addAttendance.vue?vue&type=script&setup=true&lang=js"

import "./addAttendance.vue?vue&type=style&index=0&id=b138a1aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b138a1aa"]])

export default __exports__